export default __webpack_public_path__ + "static/media/LANDING2.6d30389a.jpg";